declare namespace $ {

	type $mol_bar__sub_bog_vmap_app_align_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_align['buttons'] >
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_align_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_align['button_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_align_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_align['button_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_vmap_app_align_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_align['act'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_vmap_app_align_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_status__status_bog_vmap_app_align_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_align['note'] >
		,
		ReturnType< $mol_status['status'] >
	>
	export class $bog_vmap_app_align extends $mol_view {
		rows( ): readonly($mol_view)[]
		buttons( ): readonly($mol_view)[]
		button_hint( id: any): string
		act( id: any, next?: any ): any
		Icon( id: any): any
		button_enabled( id: any): boolean
		note( ): string
		sub( ): ReturnType< $bog_vmap_app_align['rows'] >
		Bar( ): $mol_bar
		Button( id: any): $mol_button_minor
		Note( ): $mol_status
		Icon_left( ): $mol_icon_align_horizontal_left
		Icon_center_x( ): $mol_icon_align_horizontal_center
		Icon_right( ): $mol_icon_align_horizontal_right
		Icon_top( ): $mol_icon_align_vertical_top
		Icon_center_y( ): $mol_icon_align_vertical_center
		Icon_bottom( ): $mol_icon_align_vertical_bottom
		Icon_spread_x( ): $mol_icon_align_horizontal_distribute
		Icon_spread_y( ): $mol_icon_align_vertical_distribute
	}
	
}

//# sourceMappingURL=align.view.tree.d.ts.map